import { useMsal } from '@azure/msal-react';

const LoginButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup({
      scopes: ["User.Read"], // Define scopes
    }).then(response => {
      alert("Logged in successfully!");
     // console.log("Logged in successfully:", response);
    }).catch(error => {
      alert("Login failed: " + error.message);
    //  console.error("Login failed:", error);
    });
  };

  return <button type="button" className="save-btn" onClick={handleLogin}>Logga in </button>;
};

export default LoginButton;
